export default {
  name: "StampingProfile",
  path: "/profile/documents/stamping-profile",
  title: "Stamping Profile",
  component: () => import("@/views/Profile/Components/StampingProfile")
};
